import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {LibraryEntry} from '../../models';

@Component({
    selector: 'app-item-quantification-tab',
    templateUrl: './item-quantification-tab.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ItemQuantificationTabComponent {
    @Input() entry: LibraryEntry;
    @Input() libraryType: string;
    @Input() formGroup: UntypedFormGroup;

}
